/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_StudioInputs */

const en_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Studio`)
};

const es_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Studio`)
};

const fr_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Studio`)
};

const de_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Studio`)
};

const ja_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロスタジオ`)
};

const zh_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业工作室`)
};

const ar_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استوديو احترافي`)
};

const id_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Studio`)
};

const it_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Studio`)
};

const ru_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Studio`)
};

const pt_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro Studio`)
};

const ko_pro_studio = /** @type {(inputs: Pro_StudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로 스튜디오`)
};

/**
* | output |
* | --- |
* | "Pro Studio" |
*
* @param {Pro_StudioInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pro_studio = /** @type {((inputs?: Pro_StudioInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_StudioInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_studio(inputs)
	if (locale === "es") return es_pro_studio(inputs)
	if (locale === "fr") return fr_pro_studio(inputs)
	if (locale === "de") return de_pro_studio(inputs)
	if (locale === "ja") return ja_pro_studio(inputs)
	if (locale === "zh") return zh_pro_studio(inputs)
	if (locale === "ar") return ar_pro_studio(inputs)
	if (locale === "id") return id_pro_studio(inputs)
	if (locale === "it") return it_pro_studio(inputs)
	if (locale === "ru") return ru_pro_studio(inputs)
	if (locale === "pt") return pt_pro_studio(inputs)
	return ko_pro_studio(inputs)
});